import { render, staticRenderFns } from "./ComparisonCard.vue?vue&type=template&id=445816df&scoped=true"
import script from "./ComparisonCard.vue?vue&type=script&lang=ts"
export * from "./ComparisonCard.vue?vue&type=script&lang=ts"
import style0 from "./ComparisonCard.vue?vue&type=style&index=0&id=445816df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445816df",
  null
  
)

export default component.exports